var map = {
	"./add-grey.svg": "./src/assets/svg/add-grey.svg",
	"./air.svg": "./src/assets/svg/air.svg",
	"./antFill-heart.svg": "./src/assets/svg/antFill-heart.svg",
	"./car.svg": "./src/assets/svg/car.svg",
	"./del.svg": "./src/assets/svg/del.svg",
	"./huanguan.svg": "./src/assets/svg/huanguan.svg",
	"./iconPark-share-one.svg": "./src/assets/svg/iconPark-share-one.svg",
	"./laba.svg": "./src/assets/svg/laba.svg",
	"./movedown.svg": "./src/assets/svg/movedown.svg",
	"./moveup.svg": "./src/assets/svg/moveup.svg",
	"./pingjia.svg": "./src/assets/svg/pingjia.svg",
	"./question.svg": "./src/assets/svg/question.svg",
	"./semiDesign-semi-icons-copy_add.svg": "./src/assets/svg/semiDesign-semi-icons-copy_add.svg",
	"./ship.svg": "./src/assets/svg/ship.svg",
	"./train.svg": "./src/assets/svg/train.svg",
	"./xunjia.svg": "./src/assets/svg/xunjia.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg sync recursive ^\\.\\/.*$";